// extracted by mini-css-extract-plugin
export default {"search":"BFreeTextSearch-module_search_bbced2fd","popper":"BFreeTextSearch-module_popper_dbc97947"};